<template>
    <div>
        <base-header-img img="page_05">
            <div class="base_div message_row_header">智煜动态</div>
        </base-header-img>
        <div class="base_div">
            <div class="base_div_title">
                <base-title :title="detail[id].name"></base-title>
                <div class="message_label">{{ detail[id].label }}</div>
            </div>
            <div class="message_content" v-html="detail[id].msg"></div>
            <div class="message_footer">
                <div class="message_footer_item" @click="prve">
                    上一篇：<span>{{ prevText }}</span>
                </div>
                <div class="message_footer_item" @click="next">
                    下一篇：<span>{{ nextText }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mp4 from '../assets/new-01.mp4'
import img1 from '../assets/new-01.jpg'
import img2 from '../assets/new-02.jpg'
import img3 from '../assets/new-03.jpg'
import img4 from '../assets/new-04.jpg'
import img5 from '../assets/new-05.png'
import img6 from '../assets/new-06.png'
import img7 from '../assets/new-07.png'
import img8 from '../assets/new-08.png'
import img11 from '../assets/new-11.png'
import img12 from '../assets/new-12.png'
import img13 from '../assets/new-13.png'
import img14 from '../assets/new-14.png'
import img15 from '../assets/new-15.png'
import img16 from '../assets/new-16.png'
import img17 from '../assets/new-17.png'
import img18 from '../assets/home-img-4.jpg'
import img19 from '../assets/new-19.png'
import img20 from '../assets/new-20.png'
import img21 from '../assets/new-21.png'
export default {
    name: 'message',
    data () {
        return {
            detail: {
                1: {
                    name: '智煜健康亮相2022服贸会',
                    label: '数字疗法助力“智能专病机器人与数字医疗联合研发中心”项目',
                    msg: `
                            <div class="message_text">2022年8月31日，为期6天的中国国际服务贸易交易会（服贸会）健康卫生服务专题展在首钢园区拉开序幕。作为服贸会的九大专题板块之一，健康卫生服务专题以“融创发展，共享健康”为主题，汇聚了国内外众多知名医疗机构和医药企业，涵盖了公共卫生防疫、生物医药创新、数智医疗、智慧康养、传统医药等五大领域。</div>
                            <video src="${mp4}" width="100%" height="100%" preload controls ></video>
                            <div class="message_text">在首都医科大学附属北京天坛医院的牵头下，北京智煜健康科技有限公司（智煜健康）携手北京麦迪卫康医疗科技有限公司 (2159.HK）以及苏州玖物智能科技有限公司，以共建”智能专病机器人与数字医疗联合研发中心“（联合研发中心）项目亮相服贸会。</div>
                            <img src="${img1}" />
                            <div class="message_text">智煜健康专注于创新数字智慧医疗，聚焦于数字医疗服务和数字疗法产品的研发、应用和推广，深耕心脑血管疾病领域，探索适合数字疗法的慢性疾病的预防、诊断、治疗及管理，发现、开发和提供经临床验证的基于软件的治疗方法，为临床医生提供更智能的数字化管理工具和干预方法，帮助临床提升疾病的管理效率，为患者提供更好的预后结果，改善患者的康复效果与生活质量。同时，公司广泛整合医疗技术与数字技术的应用，使临床医生与技术开发人员并肩作战，共同创造新一代的数字治疗方法。</div>
                            <div class="message_text">在本次的四方战略合作中，智煜健康将研发可独立应用也可与智能机器人相结合的数字疗法产品。公司自主研发的卒中专病领域的数字疗法产品，将应用于卒中后患者的数字化康复治疗，涵盖语言康复、运动康复、认知康复等多个方面，能够实现从院内到院外的数字化管理，帮助中国广大的卒中患者进行全程居家康复。</div>
                            <div class="message_text">智煜健康将秉承“以智慧数字力量，推动普适医疗，改变生命未来”的奋斗理念，积极投入心脑血管创新生态的建设，深耕垂直领域互联网医疗体系，为专病患者提供数字化诊疗与管理服务、为临床医生提供专病智慧医学引擎、为行业机构提供数字化服务；积极推动智能技术与医疗需求的深度融合，构建全方位全周期的数字化医疗生态，改善患者医疗结局。</div>
                            <img src="${img2}" />
                            <img src="${img3}" />
                            <img src="${img4}" />
                        `
                },
                2: {
                    name: '医阵营全平台上线，为医生提供一站式解决方案',
                    label: '',
                    msg: `
                            <div class="message_text">2023年4月，致力于成为专科医生聚集地，拓展延伸医生院外价值的医阵营1.0版本全平台正式上线，医生可在应用程序、微信小程序和网页多个端口使用。医阵营将为广大的临床医生提供高效、便捷、智能的一站式解决方案，覆盖从患者院外管理、科普患教智能创作、LDT院外诊断到专科学术交流、真实世界研究等多维度全方位的服务，拓展延伸医生的院外价值，为患者带来更多优质的医疗服务。</div>
                            <img class="img_2" src="${img5}" />
                            <div class="message_title">高效助力患者院外管理及互联网医疗服务</div>
                            <div class="message_text">医阵营提供高效的院外专病管理与互联网医疗服务，通过六大患者专病管理功能，可实现患者线上高效、长期的管理，包括登记筛查、随访干预、用药依从性管理、危险因素管理、患者教育、1对1线上咨询；此外医阵营还提供高效的线上医疗服务，包括LDT院外诊断、线上问诊及线上处方，让医疗触手可及，将医生的价值从院内延伸至院外。 </div>
                            <img class="img_2" src="${img6}" />
                            <div class="message_title">医学空间站，以数字创新工具，打造专属学术空间</div>
                            <div class="message_text">医学空间站作为医阵营的第二大板块，通过数字创新的6i工具，i开播，i临床，i调研，i创作，i录课，i分身，打造医生的专属学术空间。6i工具以人工智能助力全新学术交流与科普教育，为医生提供了高效、智能、专属的数字工具，助力医生高效创作有温度的科普内容，专业的专科学术交流空间，帮助医生提升专病诊疗能力，获取最新行业资讯与领域学术精华，分享医学知识、交流临床经验、参与学术讨论，在圈内快速提升影响力。</div>
                            <img class="img_2" src="${img7}" />
                            <div class="message_title">医研社，以科室为核心，提供多元化真实世界科研服务</div>
                            <div class="message_text">医阵营第三个板块为医研社，作为领先的临床专病科研数据平台，致力于通过真实世界研究，将多中心数据实时采集、分析、展示，赋能科室，助力科研成果转化为实际应用，支持医生做精准的临床决策，满足不同科研需求，适用于各类专科疾病临床科研场景。</div>
                            <img class="img_2" src="${img8}" />
                            <div class="message_text">医阵营1.0的全平台上线，标志着智煜在医生院外解决方案领域迈出了重要一步。我们将持续改进和优化医阵营，提升用户体验，扩大医疗资源网络，加强学术交流和临床转变科研数据的整合与应用。为医生的价值延伸至更广阔的天地，为患者提供更优质、触手可及的医疗资源与服务，为医疗行业拓展无限的可能。</div> 
                        `
                },
                3: {
                    name: '智煜健康科技携旗下三款创新医疗产品，亮相第九届天坛会',
                    label: '',
                    msg: `
                        <div class="message_text">2023年6月23日~25日，在中国卒中学会第九届学术年会（简称“天坛会”）上，智煜健康科技（简称“智煜”）展示了三款备受期待的产品：医阵营、智妙语和辈宁智能手表血压仪。这些产品凭借其先进的技术和独特的功能，赢得了广大医生的热烈关注。</div>
                        <img class="img_2" src="${img11}" />
                        <div class="image_text">展台照片</div>
                        <div class="message_text">医阵营作为专病管理数字医疗平台，为医生提供从患者院外管理到学术交流的一站式服务。医阵营的专病患者院外管理功能和数字化创新工具，吸引了众多医生前来参观体验，进行详细的咨询。他们表示，这一平台为他们的工作带来了便利，提高了工作效率，确实能够更好的为患者提供服务。</div>
                        <div class="box1">
                            <div class="box">
                                <img class="img_3" src="${img12}" /> 
                                <img class="img_3"  src="${img13}" />
                                <img class="img_3" src="${img14}" />
                            </div>
                            <div style="clear:both"></div>
                        </div>
                        <div class="message_text">医阵营不仅在展台上展示出色，还积极参与了开幕式的“2023年红手环科普创客大赛”启动仪式。作为大赛的官方投稿平台，医阵营将凭借其数字化创新工具，助力健康科普事业高质量发展。</div>
                        <img class="img_2" src="${img15}" />
                        <div class="image_text">启动仪式照片</div>
                        <div class="message_text">智妙语是智煜健康自主研发的首个数字疗法产品，主要应用于卒中后患者的数字化康复治疗，以失语症康复为核心，兼顾认知康复，帮助卒中患者实现从院内到院外的语言及认知康复管理。展会期间，医生们对智妙语的专业评估量表，院内院外的多场景应用，先进的智能自适应难度算法调节、智能课程匹配和自动判题功能，以及轻量级便携的方式表达了极大的兴趣和认可。</div>
                        <img class="img_2" src="${img16}" />
                        <div class="image_text">智妙语展台照片</div>
                        <div class="message_text">另一备受关注的产品是辈宁随安智能手表血压仪，这款医疗黑科技的产品能够实现24小时无感连续动态的血压监测。观众们对该产品的独家技术所带来的便利性表示赞赏，积极进行试戴。该设备通过先进的2合1传感器和智能算法，在确保高精准度的同时，优化了传统血压测量带来的压迫紧绷感，实现了连续监测血压的功能，使血压监测更加准确和便捷。</div>
                        <img class="img_2" src="${img17}" />
                        <div class="image_text">辈宁展台照片</div>
                        <div class="message_text">智煜健康的参展代表与医生们进行了深入的交流和互动，他们详细介绍了公司的产品特点和优势，并解答了医生们的疑问。</div>
                        <div class="message_text">致力于成为中国领先的专病数字医疗服务为核心的创新公司，智煜健康通过医阵营、智妙语和辈宁智能手表血压仪等产品的研发及合作，为医生和患者提供了更多高效、便捷、精准和个性化的解决方案。</div>
                        <div class="message_text">展会的成功举办不仅展示了智煜健康的实力和创新能力，也进一步巩固了智煜在医疗领域的声誉和市场地位。智煜健康将继续与各方紧密合作，不断探索医疗服务的边界，构建更健康的未来。</div>
                    `
                },
                4: {
                    name: '智煜健康闪耀世界数字疗法大会，引领心脑专病数字医疗未来',
                    label: '',
                    msg: `
                        <div class="message_text">2023年8月24日~26日，以“领航产业生态新未来，共建人类卫生健康共同体”为主题的首届世界数字疗法大会在海南海口举行。在这场汇聚顶级嘉宾阵容，集全球数字疗法前沿动态、政策解读、学术交流、产业合作、创新展示为一体的国际盛会上，智煜健康首席商务官富乐受邀出席了“数字疗法与全球创新产业生态论坛”，为与会者作了主题为《心脑专病数字医疗的探索》的报告，就智煜健康的心脑专病数字医疗产品矩阵与院外增值服务体系等方面进行了深入分享。</div>
                        <img class="img_2" src="${img18}" />
                        <div class="image_text">“数字疗法与全球创新产业生态论坛”现场</div>
                        <div class="message_text">数字疗法作为一个集成多项前沿技术的新兴医疗领域，通过应用数字技术，为患者提供更精准、个性化的医疗解决方案。</div>
                        <div class="message_text">近年来，随着大数据、人工智能技术的不断发展，加上利好政策的落地，数字疗法的市场规模呈逐年扩大趋势，根据Grand View Research数据，2021年我国数字疗法市场规模约为3亿美元，预计2025年将达到15亿美元，年复合增长率为56%。数字疗法在改善患者生活质量、提升医疗效率、降低医疗成本等方面展现了巨大潜力，已成为改变医疗格局的重要力量。</div>
                        <img class="img_2" src="${img19}" />
                        <div class="image_text">智煜健康首席商务官富乐现场分享</div>
                        <div class="message_text">智煜健康作为中国领先的专病数字医疗服务为核心的创新公司，致力于以数字化解决方案提升中国专病防控水平，改善患者医疗结局。公司成功构建了全面的数字医疗产品矩阵，通过医阵营、院外宝和医学空间站为医生和患者提供了前所未有的医疗支持和资源。</div>
                        <img class="img_2" src="${img20}" />
                        <div class="message_text">医生可通过医阵营，将自己的价值从院内延伸到院外，根据患者的个体化情况，更好的管理患者。同时患者通过院外宝，可以随时随地与医生进行咨询问诊等服务，让熟悉和信任的医生来管理自己，提高了医疗服务的便捷性与亲和力。</div>
                        <div class="message_text">医学空间站作为数字医疗产品矩阵的重要组成部分，通过数字化创新工具-6i、线上学院学术交流平台以及真实世界临床科研平台，为医生提供了广阔的学术研究机会，提升医生临床能力的同时，促进专科知识的共享和传播，推动了医疗领域的不断发展。</div>
                        <div class="message_text">此外智煜健康基于数字医疗产品矩阵，打造了配套的院外增值服务体系，集中覆盖了智能血压管理、数字化康复和创新院外检测三大板块。</div>
                        <img class="img_2" src="${img21}" />
                        <div class="image_text">智妙语展台照片</div>
                        <div class="message_text">公司提供了软件与硬件相结合的智能院外血压管理服务，通过可穿戴智能设备-辈宁随安智能手表血压仪，可将用户的血压数据实时传送至云端，随之产生的长期连续血压数据和用户行为数据，为医生提供了全面的患者信息。基于实时数据的反馈，医生可为患者提供个性化的健康建议，进行高效的医患沟通，实现心脑专病院外管理的真实需求的满足和医疗价值的延伸。</div>
                        <div class="message_text">数字化康复产品智妙语，是一款专注于为卒中后失语症患者提供评估与康复训练的软件产品。智妙语不仅对患者的失语问题进行全面专业的评估，还提供了便捷有效的康复训练工具。</div>
                        <div class="message_text">创新院外检测则是针对神经系统疾病的患者开发的检测工具，通过智能检测助手，辅助专科医生依据患者症状，智能判断检测项目，并进行数字化辅助诊断，形成了医-患-诊断报告的闭环系统。</div>
                        <div class="message_text">本届世界数字疗法大会为全球数字医疗领域的从业者搭建了分享和交流的平台，未来，智煜健康将继续开拓专病领域院外管理的创新，通过技术创新和产业合作，推动数字医疗创新，不断为患者提供更好的医疗体验和服务，共同构建人类卫生健康共同体的美好未来。</div>
                    `
                }
            },
            id: 1
        }
    },
    watch: {
        id: function () {
            window.scrollTo(0, 0)
        }
    },
    computed: {
        prevText () {
            let index = this.id - 1
            return this.detail[index] ? this.detail[index].name : '无'
        },
        nextText () {
            let index = this.id + 1
            return this.detail[index] ? this.detail[index].name : '无'
        }
    },
    created () {
        if (this.$route.query && this.$route.query.id) {
            this.id = parseInt(this.$route.query.id)
        }
    },
    methods: {
        prve () {
            let index = this.id - 1
            if (this.detail[index]) {
                this.id = index
            }
            // this.$router.replace(`/message?id=${index}`)
        },
        next () {
            let index = this.id + 1
            console.log(index, this.detail[index])
            if (this.detail[index]) {
                this.id = index
            }
        }
    }
}
</script>
<style>
.message_row_header {
    text-align: left;
}
.message_label {
    padding-bottom: 20px;
    font-size: 26px;
    color: #3c3c3c;
    border-bottom: 1px solid #cfced6;
}
.message_content {
    color: #3c3c3c;
    font-size: 22px;
    padding-bottom: 20px;
    border-bottom: 1px solid #cfced6;
}
.message_text {
    line-height: 36px;
    font-size: 20px;
    font-weight: 300;
    color: rgb(60, 60, 60);
    margin-bottom: 42px;
    text-align: justify;
}
.message_content img {
    margin-bottom: 42px;
    width: 100%;
    height: auto;
}
.message_footer {
    padding: 49px 0 73px 0;
    color: #3c3c3c;
    font-size: 22px;
    line-height: 40px;
}
.message_footer span {
    color: #1e1e1e;
}
.message_title {
    font-weight: bold;
}
.message_footer_item {
    cursor: pointer;
}
.img_2 {
    width: 50% !important;
    margin-left: 25%;
}
.image_text {
    line-height: 28px;
    font-size: 16px;
    font-weight: 300;
    color: rgb(96, 95, 95);
    text-align: center;
    margin-top: -35px;
    margin-bottom: 16px;
}
.box1 {
    width: 650px;
    height: 500px;
    margin: 0 auto;
    overflow: hidden;
}
.box {
    width: 1950px;
    height: 500px;
    animation: move 8s ease-out infinite;
}
.img_3 {
    float: left !important;
    height: 500px !important;
    width: 650px !important;
    object-fit: cover;
}
@keyframes move {
    0%,
    25% {
        margin-left: 0;
    }
    35%,
    60% {
        margin-left: -650px;
    }
    70%,
    100% {
        margin-left: -1300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/message.vue